import type { CrmListObjectType } from "../../management/types";

export type BaseSearchTableFilters = {
    asc: boolean;
    page: number;
    orderBy: string;
    pageSize: number;
};

export type CompanySearchTableFilters = BaseSearchTableFilters;

export type CompanySearchOtherFilters = {
    searchText: string;
};

/**
 * @deprecated use `LeadsType` from `sales-intelligence/modules/leads-search/types`
 * */
export enum LeadsType {
    Websites = "websites",
    Companies = "companies",
}

export type CompanySearchResultsStateType = {
    otherFilters: CompanySearchOtherFilters;
    isExcelExportActive: boolean;
    exportToCrmAs: CrmListObjectType.Accounts | CrmListObjectType.Leads | undefined;
};
